import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';
import { MQ_LARGE, MQ_MIDLARGE } from 'constants/mq';

/*
Overview
--------
Soundbar displays from 1 item in a prominent, featured way. The layout accounts for a single ad item to be rendered after the item.
*/
export default css`
  @media (max-width: 47.99rem) {
    .Spread__item--ad {
      padding: 0 0.5rem;
    }
  }

  @media (min-width: 48rem) {
    .Spread__item--ad,
    .Spread__item--teaser {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .Spread__items {
      flex-wrap: wrap;
      padding: 0 1.5rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      padding: 0;
    }
  }

  @supports (display: grid) {
    @media (min-width: 64rem) {
      .Spread__item--ad {
        grid-area: ad;
      }

      .Spread__item--teaser {
        grid-area: main;
      }

      .Spread__items {
        margin: 0;
        display: grid;
        grid-template:
          '.  main  .'
          'ad ad   ad'
          / 1fr ${pageWidth.large} 1fr;
        width: 100%;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns: 1fr ${pageWidth.midlarge} 1fr;
      }
    }
  }
`;
